<template>
    <ContentComp>
        <!--  -->
        <FormLayout>
            <FormLayoutRow>
                <FormLayoutLabel text="category.name"></FormLayoutLabel>
                <InputText
                    :validator="new ValidatorDef({ Min: null, Max: null, Required: true })"
                    v-model="model!.Name"
                />
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel text="race.distance"></FormLayoutLabel>
                <div class="d-flex flex-row flex-nowrap gap-2 w-25">
                    <InputNullableFloat
                        v-model="model.Km"
                        icon=""
                        posttext="km"
                        placeholder="0.000"
                    ></InputNullableFloat>
                </div>
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel>{{ $tm('stationrole.functiontype') }}</FormLayoutLabel>

                <InputSelect
                    :datasource="internalStationTypeDatasource"
                    v-model="model!.StationTypeID"
                />
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.raceid"></FormLayoutLabel>

                <InputSelect
                    :datasource="{ mapsource: RacesAsSelectLine }"
                    v-model="model!.RaceID"
                />
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.stationid"></FormLayoutLabel>

                <InputSelect
                    :datasource="{ mapsource: StationsAsSelectLine }"
                    v-model="model!.StationID"
                />
            </FormLayoutRow>

            <FormLayoutRow class="flex-fill">
                <FormLayoutLabel text="stationrole.startstoptime"></FormLayoutLabel>
                <div class="d-flex flex-row flex-nowrap gap-2 flex-fill">
                    <InputDateTime
                        format="DATETIME"
                        v-model="model!.StartTime"
                    />
                    <span class="flex-fill text-center">-</span>
                    <InputDateTime
                        format="DATETIME"
                        v-model="model!.StopTime"
                    />
                </div>
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.minlaptime"></FormLayoutLabel>
                <div class="flex-fill d-flex flex-row flex-nowrap gap-2">
                    <div class="w-md-25">
                        <InputTimespan
                            class="flex-fill"
                            format="TIME"
                            v-model="model.MinLapTime"
                        />
                    </div>
                </div>
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel text=""></FormLayoutLabel>
                <div class="d-md-flex flex-fill w-md-50 flex-column">
                    <InputBool
                        v-model="model.Start"
                        label="stationrole.start"
                    />
                    <div class="d-flex flex-row flex-nowrap ms-3 gap-3">
                        <IconComp icon="fa-arrow-turn-down-right" />
                        <InputBool
                            v-model="model.AllowNegativeStart"
                            label="stationrole.allownegativestart"
                            tooltip="stationrole.allownegativestarttooltip"
                        />
                    </div>
                    <InputBool
                        v-model="model.StartNet"
                        label="stationrole.startnet"
                    />
                </div>
                <div class="d-md-flex flex-fill w-md-50 flex-column align-self-start">
                    <InputBool
                        v-model="model.Finish"
                        label="stationrole.finish"
                    />
                    <InputBool
                        v-model="model.Mandatory"
                        label="stationrole.mandatory"
                    />
                    <InputBool
                        v-model="model.Public"
                        label="stationrole.public"
                    />
                </div>
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel
                    text="stationrole.timeselect"
                    tooltip="stationrole.timeselecttooltip"
                ></FormLayoutLabel>
                <div class="d-md-flex flex-fill gap-5">
                    <InputRadio
                        v-model="model.TimeSelect"
                        name="timeselect"
                        type="radio"
                        translationkey="stationrole.first"
                        :value="1"
                    />

                    <InputRadio
                        v-model="model.TimeSelect"
                        name="timeselect"
                        type="radio"
                        translationkey="stationrole.last"
                        :value="2"
                    />
                </div>
            </FormLayoutRow>

            <DetailCompCollapsable
                v-if="model"
                :collapsable="true"
                heading="stationrole.neutralzone"
            >
                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.isneutralzonein"
                        tooltip="stationrole.isneutralzoneintooltip"
                    ></FormLayoutLabel>
                    <InputBool v-model="model.IsNeutralZoneIn" />
                </FormLayoutRow>

                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.isneutralzoneout"
                        tooltip="stationrole.isneutralzoneouttooltip"
                    ></FormLayoutLabel>
                    <InputBool v-model="model.IsNeutralZoneOut" />
                </FormLayoutRow>
            </DetailCompCollapsable>

            <DetailCompCollapsable
                v-if="model"
                :collapsable="true"
                heading="stationrole.advancedsettings"
            >
                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.photofinish"
                        tooltip="stationrole.photofinishtooltip"
                    ></FormLayoutLabel>
                    <div class="w-25">
                        <InputNullableInt
                            v-model="model.PhotofinishMilliseconds"
                            :emptyValue="null"
                            icon=""
                            posttext="general.milliseconds"
                            placeholder="0"
                        />
                    </div>
                </FormLayoutRow>

                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.smoothinginseconds"
                        tooltip="stationrole.smoothinginsecondstooltip"
                    ></FormLayoutLabel>
                    <div class="w-25">
                        <InputNullableInt
                            v-model="model.SmoothingInSeconds"
                            :emptyValue="null"
                            icon=""
                            posttext="general.seconds"
                            placeholder="0"
                        />
                    </div>
                </FormLayoutRow>
                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.assignlappoints"
                        tooltip="stationrole.assignlappointstooltip"
                    ></FormLayoutLabel>
                    <div class="w-25">
                        <InputNullableInt
                            v-model="model.AssignLapPoints"
                            icon=""
                            posttext="contestant.points"
                        />
                    </div>
                </FormLayoutRow>
                <!--  -->

                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.pretiming"
                        tooltip="stationrole.pretimingtooltip"
                    ></FormLayoutLabel>
                    <InputBool v-model="model.Pretiming" />
                </FormLayoutRow>

                <FormLayoutRow>
                    <FormLayoutLabel
                        text="stationrole.automaticallychangerace"
                        tooltip="stationrole.automaticallychangeracetooltip"
                    ></FormLayoutLabel>
                    <InputBool v-model="model.AutomaticallyChangeRace" />
                </FormLayoutRow>
            </DetailCompCollapsable>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { IconComp, InputBool, InputDateTime, InputNullableFloat, InputRadio, InputSelect, InputText, InputTimespan } from '@/components';
import InputNullableInt from '@/components/Basic/InputNullableInt.vue';
import DetailCompCollapsable from '@/components/Detail/DetailCompCollapsable.vue';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import ContentComp from '@/components/layout/ContentComp.vue';
import { useLoaders, useTaskLoader } from '@/composeables';
import { StationRole } from '@/objects/generated';
import { ValidatorDef } from '@/objects/gui';
import { useCommonStoreRef, useEventCommonStoreRef } from '@/stores';
import { computed } from 'vue';

const model = defineModel<StationRole>({ required: true });

const { AddLoader, LoadState } = useTaskLoader();
useLoaders(AddLoader, ['RACES', 'STATIONROLES', 'STATIONTYPES']);

/**
 * The datasource for the station type select
 */
const internalStationTypeDatasource = computed(() => {
    return {
        mapsource: StationTypeWithUseStationAsSelectLine.value,
    };
});
const { StationTypeWithUseStationAsSelectLine } = useCommonStoreRef();
const { StationsAsSelectLine, RacesAsSelectLine } = useEventCommonStoreRef();
</script>
